export const checkIneligibleYear = yearParam => {
  const yearEligible = new Date().getFullYear() - 24
  const monthForYearEligible = new Date().getMonth() < 11
  const isIneligibleYear = yearParam == new Date().getFullYear() ? monthForYearEligible : yearParam < yearEligible
  return isIneligibleYear
}

export const QUESTION_TWO_KEYS = 'qp/79'

const isTrimNameMatch = (possibility, targetTrimName) => {
  const displayName = possibility.trim?.displayName
  if (!displayName || !targetTrimName) return

  return displayName.replace(/-/g, ' ').toLowerCase() === targetTrimName.toLowerCase()
}

export const getMatchingTrim = (possibilities, targetTrimName) => {
  if (!possibilities || !Array.isArray(possibilities) || !targetTrimName) return

  return possibilities.find(pos => isTrimNameMatch(pos, targetTrimName))?.trim
}
